import { createElement } from '../../adapters/dom';

export interface ErrorTemplateOptions {
  title?: string;
  message: string;
}

export function createErrorTemplate(options: ErrorTemplateOptions): HTMLDivElement {
  const wrapper = createElement('div', {
    className: 'cpw-screen cpw-screen-error'
  }) as HTMLDivElement;

  const title = createElement('h3', {
    className: 'cpw-title',
    textContent: options.title ?? 'Ошибка'
  });

  const description = createElement('p', {
    className: 'cpw-text',
    textContent: options.message
  });

  wrapper.append(title, description);

  return wrapper;
}